(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  (() => {
    const money = (cents) => {
      const currency = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(cents / 100);
    };

    const updateHeaderCount = (count) => {
      document.querySelectorAll('[data-uc-header] [data-uc-cart-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      });
    };

    document.querySelectorAll('[data-uc-cart]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const checkout = root.querySelector('[data-uc-checkout]');
      const terms = root.querySelector('[data-uc-terms]');
      const timers = new Map();
      const controllers = new Map();
      let pending = 0;

      const refreshCheckout = () => {
        if (!checkout) return;
        checkout.disabled = pending > 0 || Boolean(terms && !terms.checked);
        checkout.setAttribute('aria-busy', pending > 0 ? 'true' : 'false');
        root.classList.toggle('is-saving', pending > 0);
      };

      const renderDiscounts = (applications) => {
        const list = root.querySelector('[data-uc-discount-list]');
        if (!list) return;

        const validApplications = applications.filter((application) => {
          const title = String(application.title || '').trim();
          const amount = Number(application.total_allocated_amount || 0);
          return title.length > 0 && amount > 0;
        });

        list.replaceChildren();
        validApplications.forEach((application) => {
          const row = document.createElement('li');
          const title = document.createElement('span');
          const amount = document.createElement('strong');
          title.textContent = application.title;
          amount.textContent = `−${money(Number(application.total_allocated_amount || 0))}`;
          row.append(title, amount);
          list.append(row);
        });
        list.hidden = validApplications.length === 0;
      };

      const predictDiscount = (originalTotal) => {
        const threshold = Number(root.dataset.discountThreshold || 0);
        const rate = Number(root.dataset.discountRate || 0);
        const amount = originalTotal > threshold ? Math.round(originalTotal * rate / 100) : 0;

        renderDiscounts(amount > 0 ? [{
          title: root.dataset.discountTitle,
          total_allocated_amount: amount
        }] : []);

        return amount;
      };

      const syncDiscounts = (cart) => {
        const applications = Array.isArray(cart.cart_level_discount_applications)
          ? cart.cart_level_discount_applications.filter((application) => {
              const title = String(application.title || '').trim();
              const amount = Number(application.total_allocated_amount || 0);
              return title.length > 0 && amount > 0;
            })
          : [];
        if (applications.length > 0) {
          renderDiscounts(applications);
          return;
        }
        predictDiscount(Number(cart.original_total_price || 0));
      };

      const refreshDiscountState = async () => {
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          root.dataset.cartTotal = cart.total_price;
          root.dataset.cartOriginalTotal = cart.original_total_price;
          syncDiscounts(cart);
        } catch (error) {
          return;
        }
      };

      const discountList = root.querySelector('[data-uc-discount-list]');
      if (discountList) {
        const discountObserver = new MutationObserver(() => {
          const originalTotal = Number(root.dataset.cartOriginalTotal || 0);
          const threshold = Number(root.dataset.discountThreshold || 0);
          const currentTitle = discountList.querySelector('span');
          if (originalTotal > threshold && !String(currentTitle?.textContent || '').trim()) {
            predictDiscount(originalTotal);
          } else if (originalTotal <= threshold && !String(currentTitle?.textContent || '').trim() && !discountList.hidden) {
            renderDiscounts([]);
          }
        });
        discountObserver.observe(discountList, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['hidden']
        });
      }

      const renderOptimistic = (line, quantity) => {
        const item = root.querySelector(`[data-uc-cart-line][data-line="${line}"]`);
        if (!item) return;
        const input = item.querySelector('[data-uc-quantity-input]');
        const oldQuantity = Number(input.dataset.rendered || input.dataset.confirmed || input.value);
        const unitPrice = Number(item.dataset.unitPrice);
        const originalUnitPrice = Number(item.dataset.originalUnitPrice || unitPrice);
        const oldOriginalTotal = Number(root.dataset.cartOriginalTotal);
        const nextOriginalTotal = Math.max(0, oldOriginalTotal + (quantity - oldQuantity) * originalUnitPrice);
        const discountAmount = predictDiscount(nextOriginalTotal);
        const nextTotal = Math.max(0, nextOriginalTotal - discountAmount);
        input.value = quantity;
        input.dataset.rendered = quantity;
        item.dataset.lineTotal = quantity * unitPrice;
        const linePrice = item.querySelector('[data-uc-line-price]');
        const cartTotal = root.querySelector('[data-uc-cart-total]');
        if (linePrice) linePrice.textContent = money(quantity * unitPrice);
        if (cartTotal) cartTotal.textContent = money(nextTotal);
        root.dataset.cartTotal = nextTotal;
        root.dataset.cartOriginalTotal = nextOriginalTotal;
      };

      const commit = async (line, quantity) => {
        if (controllers.has(line)) controllers.get(line).abort();
        const controller = new AbortController();
        controllers.set(line, controller);
        pending += 1;
        refreshCheckout();

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity }),
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Cart update failed');
          const cart = await response.json();
          const item = root.querySelector(`[data-uc-cart-line][data-line="${line}"]`);
          const serverItem = cart.items[line - 1];
          if (item && serverItem) {
            const input = item.querySelector('[data-uc-quantity-input]');
            const linePrice = item.querySelector('[data-uc-line-price]');
            input.value = serverItem.quantity;
            input.dataset.confirmed = serverItem.quantity;
            input.dataset.rendered = serverItem.quantity;
            item.dataset.unitPrice = serverItem.final_price;
            item.dataset.originalUnitPrice = serverItem.original_price;
            item.dataset.lineTotal = serverItem.final_line_price;
            if (linePrice) linePrice.textContent = money(serverItem.final_line_price);
          }
          root.dataset.cartTotal = cart.total_price;
          root.dataset.cartOriginalTotal = cart.original_total_price;
          const total = root.querySelector('[data-uc-cart-total]');
          if (total) total.textContent = money(cart.total_price);
          root.querySelectorAll('[data-uc-item-count]').forEach((node) => { node.textContent = cart.item_count; });
          syncDiscounts(cart);
          updateHeaderCount(cart.item_count);
        } catch (error) {
          if (error.name !== 'AbortError') window.location.reload();
        } finally {
          if (controllers.get(line) === controller) controllers.delete(line);
          pending = Math.max(0, pending - 1);
          refreshCheckout();
        }
      };

      const queue = (input, quantity) => {
        const item = input.closest('[data-uc-cart-line]');
        const line = Number(item.dataset.line);
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const step = Number(input.step || 1);
        const normalized = Math.min(max, Math.max(min, Math.round(quantity / step) * step));
        renderOptimistic(line, normalized);
        if (timers.has(line)) window.clearTimeout(timers.get(line));
        timers.set(line, window.setTimeout(() => commit(line, normalized), 140));
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-uc-minus], [data-uc-plus]');
        if (!button) return;
        const input = button.closest('[data-uc-quantity]').querySelector('[data-uc-quantity-input]');
        const step = Number(input.step || 1);
        queue(input, Number(input.value) + (button.hasAttribute('data-uc-plus') ? step : -step));
      });

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-uc-quantity-input]')) queue(event.target, Number(event.target.value));
      });

      if (terms) terms.addEventListener('change', refreshCheckout);
      refreshCheckout();
      refreshDiscountState();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
